<template>
  <div style="z-index:999" :style="divStyle">
    <Steps :current="steps.current">
      <Step title="步骤-1" :content="steps.contents[0]"></Step>
      <Step title="步骤-2" :content="steps.contents[1]"></Step>
      <Step title="步骤-3" :content="steps.contents[2]"></Step>
      <Step title="步骤-4" :content="steps.contents[3]"></Step>
    </Steps>
    <expandStep1
      ref="step1"
      v-show="steps.child == 'step1'"
      :callback="callbackStep1"
      style="width:30%; left:30%; position:relative; margin-top:15px;"
    />
    <expandStep2
      ref="step2"
      v-if="steps.child == 'step2'"
      :condition="params.step1"
      :callback="callbackStep2"
      style="width:100%; left:0%; position:relative; margin-top:15px;"
    />
    <expandStep3
      ref="step3"
      v-if="steps.child == 'step3'"
      :instruction="params.step1"
      :callback="callbackStep3"
      style="width:100%; left:0%; position:relative; margin-top:15px;"
    />
    <expandStep4
      ref="step4"
      v-if="steps.child == 'step4'"
      :result="result.result"
      :msg="result.msg"
      :on-ok="callbackStep4"
      style="width:100%; text-align:center; position:relative; margin-top:15px;"
    />
    <template>
      <Button
        class="button"
        type="primary"
        @click="pre"
        :disabled="buttons.pre.disabled"
      >
        上一步
      </Button>
      <Button
        class="button"
        type="primary"
        @click="next"
        :disabled="buttons.next.disabled"
      >
        下一步
      </Button>
    </template>
  </div>
</template>

<script>
import expandStep1 from "./ProfileStep1.vue";
import expandStep2 from "./ProfileStep2.vue";
import expandStep3 from "./ProfileStep3.vue";
import expandStep4 from "../expand/opResult.vue";
export default {
  name: "profile",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      // style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    },
  },
  data() {
    return {
      steps: {
        current: 0,
        contents: ["选择操作指令", "选取设备", "输入参数", "执行操作"],
        child: "step1",
      },
      buttons: {
        pre: {
          disabled: true,
        },
        next: {
          disabled: true,
        },
      },
      params: {
        step1: null,
        step2: null,
        step3: null,
      },
      result: {
        result: "success",
        msg: "成功",
      },
    };
  },
  methods: {
    pre() {
      switch (this.steps.current) {
        case 1:
          this.buttons.next.disabled = false;
          this.buttons.pre.disabled = true;
          this.steps.current = 0;
          this.steps.child = "step1";
          this.params.step2 = null;
          break;
        case 2:
          this.buttons.next.disabled = false;
          this.buttons.pre.disabled = false;
          this.steps.current = 1;
          this.steps.child = "step2";
          this.params.step3 = null;
          break;
        default:
          break;
      }
    },
    next() {
      switch (this.steps.current) {
        case 0:
          this.buttons.next.disabled = true;
          this.buttons.pre.disabled = false;
          this.steps.current = 1;
          this.steps.child = "step2";
          break;
        case 1:
          this.buttons.next.disabled = true;
          this.buttons.pre.disabled = false;
          this.steps.current = 2;
          this.steps.child = "step3";
          break;
        case 2:
          this.buttons.next.disabled = true;
          this.buttons.pre.disabled = true;
          this.result = {
            result: "success",
            msg: "成功",
          };
          this.steps.current = 3;
          this.steps.child = "step4";
          break;
        default:
          break;
      }
    },
    callbackStep1(formItem) {
      this.params.step1 = formItem;
      if (formItem.selectOption && formItem.selectCondition) {
        switch (formItem.selectCondition) {
          case "idCard":
            this.buttons.next.disabled = formItem.inputIdCard ? false : true;
            break;
          case "meterId":
            this.buttons.next.disabled = formItem.inputMeterId ? false : true;
            break;
          case "address":
            this.buttons.next.disabled = formItem.addressDataSelect
              ? false
              : true;
            break;
          default:
            this.buttons.next.disabled = true;
            break;
        }
      } else {
        this.buttons.next.disabled = true;
      }
    },
    callbackStep2(params) {
      this.params.step2 = params;
      if (params) {
        this.buttons.next.disabled = false;
      } else {
        this.buttons.next.disabled = true;
      }
    },
    callbackStep3(params) {
      this.params.step3 = params;
      for (let key in params) {
        let inObj = params[key];
        if (inObj === undefined || inObj === null || inObj === "") {
          this.buttons.next.disabled = true;
          break;
        }
        this.buttons.next.disabled = false;
      }
    },
    callbackStep4() {
      this.$parent.reloadPage();
    },
  },
  components: {
    expandStep1,
    expandStep2,
    expandStep3,
    expandStep4,
  },
};
</script>

<style>
.button {
  margin-right: 5px;
}
.ivu-table-large th {
  height: 30px;
}
.ivu-table-large td {
  height: 30px;
}
.ivu-table td,
.ivu-table th {
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>
